import $ from 'jquery';

$(function () {
  const $slider = $('.fmf-agenda-slider');
  if (!$slider.length) return;

  const dates = ['12 Jan 2027', '13 Jan 2027', '14 Jan 2027'];
  const $prevBtn = $('#fmfAgendaPrevBtn');
  const $nextBtn = $('#fmfAgendaNextBtn');
  const $dateLabel = $('#fmfAgendaDateLabel');

  // 1. Initialize Slick Slider for Day slides
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    swipe: true,
    touchMove: true
  });

  function updateControls(currentIndex) {
    if ($dateLabel.length && dates[currentIndex]) {
      $dateLabel.text(dates[currentIndex]);
    }

    if (currentIndex === 0) {
      $prevBtn.addClass('disabled').attr('aria-disabled', 'true');
    } else {
      $prevBtn.removeClass('disabled').removeAttr('aria-disabled');
    }

    if (currentIndex === dates.length - 1) {
      $nextBtn.addClass('disabled').attr('aria-disabled', 'true');
    } else {
      $nextBtn.removeClass('disabled').removeAttr('aria-disabled');
    }
  }

  // Initial controls update
  updateControls(0);

  // Slide change event
  $slider.on('afterChange', function (event, slick, currentSlide) {
    updateControls(currentSlide);
  });

  // Custom Prev & Next Button clicks
  $prevBtn.on('click', function () {
    if (!$(this).hasClass('disabled')) {
      $slider.slick('slickPrev');
    }
  });

  $nextBtn.on('click', function () {
    if (!$(this).hasClass('disabled')) {
      $slider.slick('slickNext');
    }
  });

  // 2. Mobile Accordion Toggle (Independent expand/collapse)
  $(document).on('click', '.fmf-agenda-accordion-header', function (e) {
    // Only toggle accordion behavior on mobile (< 992px)
    if (window.innerWidth >= 992) return;

    e.preventDefault();
    const $header = $(this);
    const $accordion = $header.closest('.fmf-agenda-time-accordion');
    const $body = $accordion.find('.fmf-agenda-accordion-body');
    
    // Elements for adaptive height sync
    const $sliderList = $header.closest('.slick-list');
    const $activeSlide = $header.closest('.slick-slide');

    if ($accordion.hasClass('is-open')) {
      $body.slideUp({
        duration: 250,
        step: function () {
          if ($sliderList.length && $activeSlide.hasClass('slick-active')) {
            $sliderList.height($activeSlide.outerHeight());
          }
        },
        complete: function () {
          $accordion.removeClass('is-open');
          $header.attr('aria-expanded', 'false');
          if ($sliderList.length && $activeSlide.hasClass('slick-active')) {
            $sliderList.height($activeSlide.outerHeight());
          }
        }
      });
    } else {
      $body.slideDown({
        duration: 250,
        step: function () {
          if ($sliderList.length && $activeSlide.hasClass('slick-active')) {
            $sliderList.height($activeSlide.outerHeight());
          }
        },
        complete: function () {
          $accordion.addClass('is-open');
          $header.attr('aria-expanded', 'true');
          if ($sliderList.length && $activeSlide.hasClass('slick-active')) {
            $sliderList.height($activeSlide.outerHeight());
          }
        }
      });
    }
  });
});
